import React from "react";

import { formatAmount } from "../../../../helpers/format";

export default function ForamtPrice(props) {
    const {
        price = 0,
    } = props;

    return (
        <>
            {formatAmount(price, "£")}
        </>
    )
}